export type AgentDetailStatus = "idle" | "loading" | "success" | "error";
export type AgentSaveStatus = "idle" | "saving" | "success" | "error";

export enum AgentDetailSectionEnum {
    PERSONAL_INFORMATION = "personalInformation",
    BUSINESS_INFORMATION = "businessInformation",
    CONTRACT_AND_LICENSING_INFORMATION = "contractAndLicensingInformation",
}

export type AgentDetailSection = AgentDetailSectionEnum;

export interface IAgentRestrictedFields {
    personalInformation: string[];
    businessInformation: string[];
    contractAndLicensingInformation: string[];
    actionButtons: string[];
}

export interface IAgentPersonalInformation {
    userId: number;
    parentUserId: number;
    createdOn: string | null;
    lastLoginOn: string | null;
    isActive: boolean | null;
    firstName: string | null;
    lastName: string | null;
    userDisplayImage: string | null;
    email: string | null;
    domain: string | null;
    subDomain: string | null;
    dateOfBirth: string | null;
    placeOfBirth: string | null;
    userTimeZone: string | null;
    ssnNumber: string | null;
    npnNumber: string | null;
    primaryPhoneNumber: string | null;
    secondaryPhoneNumber: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    driversLicenseNumber: string | null;
    driversLicenseState: string | null;
    unitNumber: string | null;
}

export interface IAgentBusinessInformation {
    businessName: string | null;
    primaryPhoneNumber: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    faxNumber: string | null;
    suiteNumber: string | null;
    userType: string | null;
}

export interface IAgentProductDetails {
    productUid: string;
    productName: string | null;
    commissionUid: string;
    productCommissionLevel: string | null;
    agentWritingNumber: string | null;
    agencyNumber: string | null;
    isApproved: boolean;
    carrier: string | null;
}

export interface IAgentLicensedState {
    stateId: number;
    stateName: string;
}

export interface IAgentHierarchyInformation {
    userId: number;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    userType: string | null;
    agencyNumber: string | null;
    writingNumber: string | null;
    isActive: boolean;
    agencyName: string | null;
    downLine: IAgentHierarchyInformation[];
}

export interface IAgentContractAndLicensingInformation {
    licensedStates: IAgentLicensedState[];
    agentProductDetails: IAgentProductDetails[];
    hierarchyInformation: IAgentHierarchyInformation[];
}

export interface IAgentDetails {
    restrictedFields: IAgentRestrictedFields;
    hiddenFields: IAgentRestrictedFields;
    personalInformation: IAgentPersonalInformation;
    businessInformation: IAgentBusinessInformation;
    contractAndLicensingInformation: IAgentContractAndLicensingInformation;
}

export interface IState {
    stateId: number;
    stateCode: string | null;
    stateTitle: string | null;
    countryId: number;
}

export type AgentDetailSavePayload = {
    userId: number;
    [AgentDetailSectionEnum.PERSONAL_INFORMATION]?: IAgentPersonalInformation;
    [AgentDetailSectionEnum.BUSINESS_INFORMATION]?: IAgentBusinessInformation;
    [AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION]?: IAgentContractAndLicensingInformation;
};

export interface AgentDetailContractSubScope {
    section: AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION;
    subField: "licensedStates" | "agentProductDetails";
}

export type AgentDetailSaveScope = "all" | AgentDetailSectionEnum | AgentDetailContractSubScope;

export interface AgentDetailSlice {
    activeUserId: number | null;
    data: IAgentDetails | null;
    draft: IAgentDetails | null;
    status: AgentDetailStatus;
    saveStatus: AgentSaveStatus;
    saveError: string | null;
    error: string | null;
    isEditMode: boolean;
}
